<!-- zoom页面 -->
<template>
  <div class="mentor-zoom">
    <!-- zoom 提示 -->
    <div v-if="!(appDetail.videoType === 'TENCENT'?true:false)">
     <zoom-piao-chuang></zoom-piao-chuang>
    </div>
    <div class="dis-40">
      <!-- zoom 视频 -->
      <template v-if=" appDetail.videoType === 'ZOOM' && appDetail.type && appDetail.type !== 'INTERVIEW'">
        <coach-zoom-banner :appDetail="appDetail" :isPackageId="isPackageId"></coach-zoom-banner>
      </template>
      <template v-if=" appDetail.videoType === 'ZOOM' && appDetail.type === 'INTERVIEW' && appDetail.menteeResultTimeStr">
        <project-zoom-banner :appDetail="appDetail"></project-zoom-banner>
      </template>
      <!-- 腾讯视频 -->
      <template v-if=" appDetail.videoType === 'TENCENT'">
        <coach-tencent-video :appDetail="appDetail" :isPackageId="isPackageId"></coach-tencent-video>
      </template>
    </div>
    <div class="dis-40">
      <mentor-detail :appDetail="appDetail"
                     :id="id"
                     :isPackageId="isPackageId"></mentor-detail>
    </div>
    <!-- 课时信息 -->
    <div class="dis-40 course-info" v-if="courseInfo && (courseInfo.name || courseInfo.suggestTimeDesc  || courseInfo.guide || courseInfo.purpose || courseInfo.pptUrl || courseInfo.systemFileUrl)">
        <div class="course-info-main">
          <h1>
            课程信息
          </h1>
          <ul>
            <li><div class="course-main"><span class="course-title-left">课程名称:</span><span v-html="courseInfo.name"></span></div></li>
            <li><div class="course-main"><span  class="course-title-left">课程时长:</span><span v-html="courseInfo.suggestTimeDesc "></span></div></li>
            <li v-show="isShow"></li>
            <template v-if="isShow">
              <li><div class="course-main"><span  class="course-title-left">课程详细指引:</span><span v-html="courseInfo.guide"></span></div></li>
              <li><div class="course-main"><span  class="course-title-left">课程效果:</span><span v-html="courseInfo.purpose"></span></div></li>
            </template>
            <li :class="[isShow?'dis-64':'']">
              <span @click="isShow = !isShow"
                    class="click-detail">{{isShow?'收起详情':'展开详情'}}</span>
            </li>
          </ul>
        </div>
    </div>
    <div class="dis-40">
      <component :is="componentId"
                 :appDetail="appDetail"
                 :isPackageId="isPackageId"
                 @on-evaluate-suc="getAppDeatil"></component>
    </div>
    <!-- 聊天 -->
    <div>
      <websocket-chat-modal :appDetail="appDetail" :id="id"></websocket-chat-modal>
    </div>
    <!-- 讨论区 -->
    <!--<div class="dis-40 mentor-zoom-dicuss">-->
      <!--<div>-->
        <!--<div>-->
          <!--<div class="mentor-zoom-dicuss-con">-->
            <!--<zlr-discuss title="其它信息">-->
              <!--<template v-if="commentList.length>0">-->
                <!--<zlr-discuss-item v-for="(item, index) in commentList"-->
                                  <!--:key="index"-->
                                  <!--:avatar="item.avaurl || (item.createRole === 'MENTOR'? MentorAvatar: MenteeAvatar)"-->
                                  <!--:name="item | filterName"-->
                                  <!--:time="item.createTime"-->
                                  <!--:content="item.content"></zlr-discuss-item>-->
              <!--</template>-->
              <!--<zlr-empty v-else></zlr-empty>-->
            <!--</zlr-discuss>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="dis-40 mentor-zoom-publish">-->
      <!--<div>-->
        <!--<div>-->
          <!--<h1>添加讨论</h1>-->
          <!--<div class="mentor-zoom-publish-con">-->
            <!--<div class="mentor-zoom-publish-left">-->
              <!--<img :src="userAvatar"-->
                   <!--alt="">-->
            <!--</div>-->
            <!--<div class="mentor-zoom-publish-right">-->
              <!--<editor ref="analysisEditor"-->
                      <!--:cache=false-->
                      <!--v-model="content" />-->
              <!--<div class="mentor-zoom-publish-btn">-->
                <!--<Button class="btn"-->
                        <!--:loading="isSend"-->
                        <!--@click="sendHandle">发出讨论</Button>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
// less
import './application/zoom.less'
//  api
import { getAppDeatil } from '@/api/appointment'
import { createComments, getCommentsPage } from '@/api/comments'
import { infoQueryDetail } from '@/api/info'
// images
import MentorAvatar from '@/assets/images/home/mentor-avatar.svg'
import MenteeAvatar from '@/assets/images/home/mentee-avatar.svg'
// components
import CoachZoomBanner from './application/coach-zoom-banner'
import ProjectZoomBanner from './application/project-zoom-banner'
import CoachTencentVideo from './application/tencent-video'
import MentorDetail from './application/mentor-detail'
import discuss from '_c/discuss'
import Editor from '_c/editor/editor'
import ConfirmTime from './application/confirm-time'
import ZlrEmpty from '_c/empty/empty'
import Feedback from './application/feedback-main'
import ZoomPiaoChuang from '../mentor/components/application-mentor-zoom'
import WebsocketChatModal from './application/websocket-chat-modal'
// constant
import { mapState } from 'vuex'
export default {
  name: 'application-detail',
  components: {
    CoachZoomBanner,
    ProjectZoomBanner,
    CoachTencentVideo,
    MentorDetail,
    ZlrDiscuss: discuss.ZlrDiscuss,
    ZlrDiscussItem: discuss.ZlrDiscussItem,
    Editor,
    ConfirmTime,
    ZlrEmpty,
    Feedback,
    ZoomPiaoChuang,
    WebsocketChatModal
  },
  data () {
    return {
      MentorAvatar,
      MenteeAvatar,
      id: this.$route.query.id,
      appDetail: {},
      content: '',
      isSend: false,
      commentList: [],
      componentId: '',
      feedbackDetail: {},
      isPackageId: false,
      packageId: '',
      courseInfo: {},
      isShow: false
    }
  },
  computed: {
    ...mapState({
      'userAvatar' (state) {
        return state.user.userAvatar
      }
    })
  },
  created () {
    // 获取信息
    this.getDetail()
  },
  mounted () {
    this.getAppDeatil()
    this.getCommentsPage()
  },
  methods: {
    // 获取用户信息
    getDetail () {
      infoQueryDetail({}).then(res => {
        if (res.code === 0) {
          this.packageId = res.data.model.packageId
          if (this.packageId === 120 || this.packageId === 121) {
            this.isPackageId = true
          } else {
            this.isPackageId = false
          }
        }
      })
    },
    // 获取学生信息
    getAppDeatil () {
      getAppDeatil({
        id: this.id
      }).then(res => {
        this.appDetail = res.data.model
        if (res.data.model.courseInfo) {
          this.courseInfo = res.data.model.courseInfo
        } else {
          this.courseInfo = {}
        }
        this.mapComponents()
      })
    },
    // 获取评论列表
    getCommentsPage () {
      getCommentsPage({
        appId: this.id
      }).then(res => {
        this.commentList = res.data.page.result
      })
    },
    // 发表评论
    sendHandle () {
      if (!this.content) return false
      this.isSend = true
      createComments({
        type: 'APPOINTMENT',
        appId: this.id,
        content: this.content
      }).then(res => {
        this.$refs['analysisEditor'].resetHtml()
        this.getCommentsPage()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isSend = false
      })
    },
    mapComponents () {
      let status = this.appDetail.statu
      let name = ''
      if (status === 'TO_BE_COMPLETE_MENTEE') {
        name = ConfirmTime
      }
      if (status === 'COMPLETE' || status === 'HAS_EVALUATE') {
        name = Feedback
      }
      this.componentId = name
    }
  },
  filters: {
    filterName (item) {
      let name = ''
      if (item.createRole === 'MENTOR') {
        name = item.mentorType + ' Mentor - '
        name += item.mentorName
      } else {
        name = item.menteeName
      }
      return name
    }
  }
}
</script>
<style lang='less' scoped>
.course-info{
  background: #fff;
  padding: 24px 0 32px;
  .course-info-main{
    margin: 0 auto;
    width: 1280px;
    padding-left: 160px;
    h1{
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 30px;
      font-weight: normal;
      margin-bottom: 24px;
    }
    .click-detail {
      padding-top:32px;
      display:inline-block;
      color: #6589dd;
      cursor: pointer;
    }
    ul li>div{
      line-height: 24px;
      padding-bottom: 7px;
      display:flex;
      .course-title-left{
        width:100px;
      }
    }
  }
}
</style>
